<template>
  <div class="container">
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div class="capsula">
      <a href="http://www.dentalia.com/"
        ><i class="fa fa-home"></i><span>Inicio</span></a
      >
      <img alt="Vue logo" src="../assets/dentalia.jpg" />
      <div class="item-2">
        <h4>FACTURACIÓN EN LINEA</h4>
      </div>
      <div class="item-3" v-if="selected !== 'B'">
        <h4>Genera tus facturas en 4 sencillos pasos</h4>
      </div>
      <div class="tab_container" v-if="selected !== 'B'">
        <input
          id="tab1"
          type="radio"
          name="tabs"
          :checked="tab1"
          :disabled="disabled1"
        />

        <label for="tab1"><span>1</span></label>

        <input
          id="tab2"
          type="radio"
          name="tabs"
          :checked="tab2"
          :disabled="disabled2"
        />
        <label for="tab2"><span>2</span></label>

        <input
          id="tab3"
          type="radio"
          name="tabs"
          :checked="tab3"
          :disabled="disabled3"
        />
        <label for="tab3"><span>3</span></label>

        <input
          id="tab4"
          type="radio"
          name="tabs"
          :checked="tab4"
          :disabled="disabled4"
        />
        <label for="tab4"><span>4</span></label>

        <section id="content1" class="tab-content">
          <h3>Ingresa tu ID de Paciente</h3>
          <b-row>
            <b-col cols="4">
              <b-form-group
                id="input-group-1"
                class="labels"
                label="ID de Paciente"
                label-for="input-1"
                description=""
              >
                <b-form-input
                  id="input-1"
                  class="input"
                  type="text"
                  v-model="idPaciente"
                  required
                ></b-form-input>
              </b-form-group>
              <b-form-group class="radios">
                <b-form-radio
                  v-model="option"
                  class="mb-2 float-left"
                  name="some-radios"
                  value="A"
                  required
                  >Facturar nuevo recibo</b-form-radio
                >
                <b-form-radio
                  v-model="option"
                  class="float-left"
                  name="some-radios"
                  value="B"
                  required
                  >Consultar facturas anteriores</b-form-radio
                >
              </b-form-group>
              <b-button
                class="btn mt-1 mr-2"
                variant="outline-primary"
                v-b-tooltip.hover
                @click="siguiente()"
                >Siguiente</b-button
              >
            </b-col>
            <b-col cols="6">
              <div class="imagenes">
                <img class="zoom" src="../assets/recibo.png" alt="Recibo" />
                <span>El número lo encuentras aqui.</span>
              </div>
            </b-col>
          </b-row>
        </section>

        <section id="content2" class="tab-content">
          <h3>Selleciona tu recibo a facturar</h3>
          <b-row>
            <b-col cols="12">
              <b-table
                id="recibos"
                thead-tr-class="columnas"
                :items="datosTablaRecibo"
                :fields="fields"
                :per-page="registrosPorPagina"
                :current-page="paginaActual"
                responsive
                class="tabla1"
              >
                <template v-slot:cell(montopagado)="row">
                  {{ row.item.montopagado | moneda }}
                </template>
                <template v-slot:cell(saldo)="row">
                  {{ row.item.saldo | moneda }}
                </template>
                <template v-slot:cell(aplicacion)="row">
                  {{ row.item.aplicacion | moneda }}
                </template>

                <template v-slot:cell(fecha)="row">
                  {{ row.item.fecha | formatoFecha }}
                </template>
                <template v-slot:cell(idRecibo)="row">
                  {{
                    row.item.numeroRecibo !== null
                      ? row.item.numeroRecibo
                      : row.item.idRecibo
                  }}
                </template>
                <template v-slot:cell(Selec.)="row">
                  <b-form-checkbox
                    v-if="!row.item.facturado && row.item.activo"
                    :id="'checkbox-' + row.item.idRecibo"
                    v-model="row.item.seleccion"
                    :name="'checkbox-' + row.item.idRecibo"
                    value="accepted"
                    unchecked-value="not_accepted"
                  >
                  </b-form-checkbox>
                </template>
              </b-table>
              <div align="center" v-if="loaderRecibo">
                <b-spinner variant="primary" label="Spinning"></b-spinner>
              </div>
              <b-col v-if="!loaderRecibo">
                <b-alert
                  v-if="datosTablaRecibo.length === 0"
                  variant="warning"
                  show
                  >No hay datos
                </b-alert>
              </b-col>
            </b-col>
          </b-row>
          <b-col v-if="!loaderRecibo">
            <b-pagination
              v-if="
                datosTablaRecibo !== undefined && datosTablaRecibo.length > 5
              "
              align="center"
              v-model="paginaActual"
              :total-rows="datosTablaRecibo.length"
              :per-page="registrosPorPagina"
              aria-controls="my-table1"
            ></b-pagination>
          </b-col>
          <div class="mt-5">
            <b-button variant="outline-primary" @click="siguiente2()"
              >Siguiente
            </b-button>
            <b-button
              class="ml-3"
              variant="outline-primary"
              v-b-tooltip.hover
              @click="cancelar()"
              >Cancelar</b-button
            >
          </div>
        </section>

        <section id="content3" class="tab-content">
          <h3>Ingresa o confirma tus datos</h3>
          <b-container fluid>
            <b-button
              class="mt-2 mr-1 add"
              variant="outline-primary"
              v-b-tooltip.hover
              @click="add()"
              >Agregar datos fiscales</b-button
            >
            <b-row class="mt-3">
              <b-col cols="6">
                <b-form-group
                  class="labels"
                  id="idfactura"
                  label="RFC para factura:"
                  label-for="input-1"
                >
                  <b-form-select v-model="factura.idDatosFiscales" class="mb-3">
                    <b-form-select-option
                      v-for="item in datosFiscales"
                      :key="item.rfc"
                      :value="item"
                      >{{ item.rfc }}
                    </b-form-select-option>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group
                  class="labels"
                  id="input-group-1"
                  label="Uso de CFDI:"
                  label-for="input-1"
                >
                  <b-form-select v-model="factura.cfdi" class="mb-3" v-if="factura.idDatosFiscales != null && factura.idDatosFiscales.tipoPersona == 2">
                    <b-form-select-option v-if="aparecerDOI" value="D01"
                      >Honorarios médicos, dentales y gastos hospitalarios (D01)
                    </b-form-select-option>
                    <b-form-select-option value="G03"
                      >Gastos en general (G03)
                    </b-form-select-option>
                  </b-form-select>

                  <b-form-select v-model="factura.cfdi" class="mb-3" v-if="factura.idDatosFiscales != null && factura.idDatosFiscales.tipoPersona == 1">
                    <b-form-select-option value="G03">Gastos en general (G03)</b-form-select-option>
                  </b-form-select>
                  
                </b-form-group>
              </b-col>
            </b-row>
            <b-form-group
              id="idfactura"
              class="mt-3 mb-4 labels"
              label="Nombre de la Razón Social:"
              label-for="input-1"
            >
              <p class="nombre" v-if="factura.idDatosFiscales != null">
                {{ factura.idDatosFiscales.nombreCompleto }}
              </p>
              <p v-else></p>
            </b-form-group>
            <span style="font-size: 12.5px; color: darkgray; margin-right: 7px"
              >Opciones avanzadas</span
            >
            <hr style="margin-top: 0.1rem" />
            <b-row>
              <b-col>
                <b-form-checkbox
                  class="labels mr-4"
                  id="checkbox-1"
                  v-model="factura.datosPaciente"
                  name="checkbox-1"
                >
                  Mostrar datos del paciente
                </b-form-checkbox>
              </b-col>
              <b-col>
                <b-form-checkbox
                  class="labels mr-3"
                  id="checkbox-2"
                  v-model="factura.desglosada"
                  name="checkbox-2"
                >
                  Factura desglosada
                </b-form-checkbox>
              </b-col>
            </b-row>
          </b-container>
          <div class="mt-4 ml-3">
            <b-button
              class="mr-3"
              variant="outline-primary"
              :disabled="loaderFacturar"
              @click="realizarFactura()"
            >
              <span v-if="!loaderFacturar">Facturar</span>
              <span v-if="loaderFacturar">
                <b-spinner small></b-spinner>
                Facturando...
              </span>
            </b-button>

            <b-button
              class="mr-3"
              variant="outline-primary"
              v-b-tooltip.hover
              @click="cancelar()"
              >Cancelar</b-button
            >
          </div>
        </section>

        <section id="content4" class="tab-content">
          <h3>Descarga tus facturas</h3>
          <b-row>
            <b-col cols="12">
          <b-table
            id="facturas"
            thead-tr-class="columnas"
            :items="datosTablaFacturas"
            :fields="fieldsFacturas"
            :per-page="registrosPorPaginaFacturas"
            :current-page="paginaActualFacturas"
            responsive
            class="tabla2"
            hover
          >
            <template v-slot:cell(fecha)="row">
              {{ row.item.fecha | formatoFecha }}
            </template>

            <template v-slot:cell(total)="row">
              {{ row.item.total | moneda }}
            </template>

            <template v-slot:cell(Descargar)="row">
              <b-button-group v-if="row.item.estatus.includes('xito')">
                <b-button
                  size="sm"
                  @click="zipFactura(row.item)"
                  variant="outline-primary"
                  :disabled="row.item.loaderRecibo"
                  ><em
                    v-if="!row.item.loaderRecibo"
                    class="fa fa-download"
                  ></em>
                  <b-spinner small v-else label="Spinning"></b-spinner>
                </b-button>
              </b-button-group>
            </template>
          </b-table>
          <div align="center" v-if="loaderFacturas">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loaderFacturas">
            <b-alert
              v-if="datosTablaFacturas.length === 0"
              variant="warning"
              show
              >No hay datos
            </b-alert>
          </b-col>
          <b-col v-if="!loaderFacturas">
            <b-pagination
              v-if="
                datosTablaFacturas !== undefined &&
                datosTablaFacturas.length > 5
              "
              align="center"
              v-model="paginaActualFacturas"
              :total-rows="datosTablaFacturas.length"
              :per-page="registrosPorPaginaFacturas"
              aria-controls="recibos"
            ></b-pagination>
          </b-col>

          <b-button
            class="mt-4"
            variant="outline-primary"
            v-b-tooltip.hover
            @click="cancelar()"
            >Terminar</b-button
          >
        </b-col>
          </b-row>
        </section>
      </div>

      <b-row v-if="selected == 'B'">
        <b-col cols="12">
          <b-table
            id="facturas"
            thead-tr-class="columnas"
            :items="datosTablaFacturas"
            :fields="fieldsFacturas"
            :per-page="registrosPorPaginaFacturas"
            :current-page="paginaActualFacturas"
            responsive
            class="tabla2"
            hover
          >
            <template v-slot:cell(fecha)="row">
              {{ row.item.fecha | formatoFecha }}
            </template>

            <template v-slot:cell(total)="row">
              {{ row.item.total | moneda }}
            </template>

            <template v-slot:cell(Descargar)="row">
              <b-button-group v-if="row.item.estatus.includes('xito')">
                <b-button
                  size="sm"
                  @click="zipFactura(row.item)"
                  variant="outline-primary"
                  :disabled="row.item.loaderRecibo"
                  ><em
                    v-if="!row.item.loaderRecibo"
                    class="fa fa-download"
                  ></em>
                  <b-spinner small v-else label="Spinning"></b-spinner>
                </b-button>
              </b-button-group>
            </template>
          </b-table>
          <div align="center" v-if="loaderFacturas">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loaderFacturas">
            <b-alert
              v-if="datosTablaFacturas.length === 0"
              variant="warning"
              show
              >No hay datos
            </b-alert>
          </b-col>
          <b-col v-if="!loaderFacturas">
            <b-pagination
              v-if="
                datosTablaFacturas !== undefined &&
                datosTablaFacturas.length > 5
              "
              align="center"
              v-model="paginaActualFacturas"
              :total-rows="datosTablaFacturas.length"
              :per-page="registrosPorPaginaFacturas"
              aria-controls="recibos"
            ></b-pagination>
          </b-col>

          <b-button
            class="mt-4"
            variant="outline-primary"
            v-b-tooltip.hover
            @click="cancelar()"
            >Regresar</b-button
          >
        </b-col>
      </b-row>

      <div class="caja" v-if="selected !== 'B'">
        Recuerda que cuentas con 30 días naturales para facturar un recibo.
        <br />
        Si pagas anticipadamente, no olvides facturar tu recibo de pago
        anticipado.
      </div>

      <p>
        Para cualquier duda en tu factura escríbenos a
        <span> contacto@dentalia.com,</span> no olvides incluir: nombre del
        paciente, RFC, clínica y datos fiscales.
      </p>
    </div>

    <b-modal
      v-model="showModal"
      :title="titulo"
      size="lg"
      centered
    >
      <div fluid>
        <b-row>
          <b-col>
            <b-form-group>
              <b-form-radio-group @input="listaFiscal"
                id="tipo"
                v-model="datoFiscal.tipoPersona"
                name="tipo"
              >
                <b-form-radio :value="2">Fisica</b-form-radio>
                <b-form-radio :value="1">Moral</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <label for="rfc"
                >RFC
                <validacion />
              </label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="menu-button-wide"></b-icon>
                </b-input-group-prepend>
                <b-form-input
                  id="rfc"
                  name="rfc"
                  placeholder="RFC"
                  v-model="$v.datoFiscal.rfc.$model"
                  @input="datoFiscal.rfc = datoFiscal.rfc.toUpperCase()"
                  :state="validateState('rfc')"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <label for="regimen">Regimen Fiscal
                <validacion/>
              </label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="menu-button-wide"></b-icon>
                </b-input-group-prepend>
                <b-form-select id="regimen" name="regimen" placeholder="Regimen Fiscal"
                               v-model="$v.datoFiscal.regimenFiscal.$model"
                               :options="regimenFiscales"
                               value-field="idRegimenFiscal"
                               text-field="nombre"
                               :state="validateState('regimenFiscal')"
                ></b-form-select>

              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <h5>Razón social</h5>
        <hr />
        <b-row v-if="datoFiscal.tipoPersona === 2">
          <b-col>
            <b-form-group>
              <label for="nombre"
                >Nombre(s)
                <validacion />
              </label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="menu-button-wide"></b-icon>
                </b-input-group-prepend>
                <b-form-input
                  v-model="$v.datoFiscal.nombre.$model"
                  :state="validateState('nombre')"
                  id="nombre"
                  name="rfc"
                  placeholder="Nombre"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
            <b-form-group label-for="input-name" v-if="nameInvalid == true">
                  <h5>Nombre Completo: <span class="text-secondary"><small>{{datoFiscal.nombreCompleto}}</small></span></h5>
                  
                  <p class="txt-rojo">El nombre completo no coincide con el nombre y/o apellidos</p>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="datoFiscal.tipoPersona === 1">
          <b-col>
            <b-form-group>
              <label for="nombre"
                >Nombre de la razón social
                <validacion />
              </label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="menu-button-wide"></b-icon>
                </b-input-group-prepend>
                <b-form-input
                  v-model="$v.datoFiscal.nombreCompleto.$model"
                  :state="validateState('nombreCompleto')"
                  id="nombre"
                  name="rfc"
                  placeholder="Nombre"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="datoFiscal.tipoPersona === 2">
          <b-col>
            <b-form-group>
              <label for="paterno"
                >Apellido paterno
                <validacion />
              </label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="menu-button-wide"></b-icon>
                </b-input-group-prepend>
                <b-form-input
                  id="paterno"
                  name="paterno"
                  placeholder="Apellido paterno"
                  v-model="$v.datoFiscal.paterno.$model"
                  :state="validateState('paterno')"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group>
              <label for="materno"
                >Apellido materno
                <validacion />
              </label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="menu-button-wide"></b-icon>
                </b-input-group-prepend>
                <b-form-input
                  id="materno"
                  name="materno"
                  placeholder="Apellido materno"
                  v-model="$v.datoFiscal.materno.$model"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <label for="correo"
                >Correo electrónico
                <validacion />
              </label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="menu-button-wide"></b-icon>
                </b-input-group-prepend>
                <b-form-input
                  type="email"
                  id="correo"
                  name="correo"
                  placeholder="Correo"
                  v-model="$v.datoFiscal.correo.$model"
                  :state="validateState('correo')"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <h5>
              Dirección
              <span class="text-secondary"><small>(Opcional)</small></span>
            </h5>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <label for="calle">Calle </label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="menu-button-wide"></b-icon>
                </b-input-group-prepend>
                <b-form-input
                  id="calle"
                  name="calle"
                  placeholder="Calle"
                  v-model="datoFiscal.calle"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group>
              <label for="numero">Número </label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="menu-button-wide"></b-icon>
                </b-input-group-prepend>
                <b-form-input
                  id="numero"
                  name="numero"
                  placeholder="Número"
                  v-model="datoFiscal.numero"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <label for="cp">CP </label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="menu-button-wide"></b-icon>
                </b-input-group-prepend>
                <b-form-input
                  id="cp"
                  name="cp"
                  placeholder="CP"
                  v-model="$v.datoFiscal.cp.$model"
                  :state="validateState('cp')"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group>
              <label for="colonia">Colonia </label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="menu-button-wide"></b-icon>
                </b-input-group-prepend>
                <v-select
                    id="colonia"
                    style="width: 90%"
                    name="colonia"
                    label="nombreLocalidad"
                    placeholder="Selecciona una colonia"
                    v-model="datoFiscal.colonia"
                    :reduce="(nom) => nom.nombreLocalidad"
                    :options="localidades"
                ></v-select>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <label for="pais">País de residencia </label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="menu-button-wide"></b-icon>
                </b-input-group-prepend>
                <b-form-input
                  id="pais"
                  name="pais"
                  placeholder="País"
                  v-model="datoFiscal.pais"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group>
              <label for="estado">Estado </label>
              <b-input-group size="sm" class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="menu-button-wide"></b-icon>
                </b-input-group-prepend>
                <b-form-input
                  id="estado"
                  name="estado"
                  placeholder="Estado"
                  v-model="datoFiscal.estado"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
      <div slot="modal-footer" class="modal-footer">
        <b-button
          class="mr-3"
          variant="outline-primary"
          :disabled="loaderAcciones"
          @click="guardarRFC()"
        >
          <span v-if="!loaderAcciones">Guardar</span>
          <span v-if="loaderAcciones">
            <b-spinner small></b-spinner>
            Cargando...
          </span>
        </b-button>
        <b-button
          variant="outline-danger"
          :disabled="loaderAcciones"
          @click="cerrarModal()"
          >Cancelar</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
import * as JSZip from "jszip";
import { saveAs } from "file-saver";
import {maxLength, numeric, required, email, minLength} from "vuelidate/lib/validators";

import { LoginService } from "@/apiServices/login/LoginService";
export default {
  name: "facturaLinea",
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    datosTablaRecibo: [],
    datosTablaFacturas: [],
    datosFiscales: [],
    datosFacturasGeneradas: [],
    fields: [
      "Selec.",
      { key: "fecha", label: "Fecha", sortable: true },
      { key: "clinica", label: "Clinica", sortable: true },
      { key: "montopagado", label: "Pago", sortable: true },
      { key: "aplicacion", label: "Aplicacion de saldo", sortable: true },
      { key: "saldo", label: "Saldo", sortable: true },
      { key: "idRecibo", label: "Recibo", sortable: true },
    ],
    fieldsFacturas: [
      { key: "idFactura", label: "No.", sortable: true },
      { key: "total", label: "Total", sortable: true },
      { key: "idRecibo", label: "Recibo", sortable: true },
      { key: "clinica", label: "Clínica", sortable: true },
      { key: "fecha", label: "Fecha", sortable: true },
      "Descargar",
    ],
    factura: {
      recibos: [],
      idDatosFiscales: null,
      cfdi: null,
      idClinica: null,
      datosPaciente: false,
      desglosada: false,
      permiso: null
    },
    regimenFiscales: [],
    datoFiscal: {
      idPaciente: null,
      idDatosFiscales: null,
      nacionalidad: null,
      rfc: null,
      tipoPersona: 1,
      nombre: null,
      nombreCompleto: null,
      paterno: null,
      materno: null,
      calle: null,
      numero: null,
      colonia: null,
      cp: null,
      pais: null,
      estado: null,
      correo: null,
      regimenFiscal: null
    },
    localidades: [],
    idPaciente: null,
    loaderRecibo: false,
    loaderFacturar: false,
    loaderFacturas: false,
    loaderAcciones: false,

    registrosPorPagina: 5,
    paginaActual: 1,

    registrosPorPaginaFacturas: 5,
    paginaActualFacturas: 1,

    option: null,
    tab1: false,
    tab2: false,
    tab3: false,
    tab4: false,
    disabled1: false,
    disabled2: false,
    disabled3: false,
    disabled4: false,
    selected: null,
    aparecerDOI: true,
    showModal: false,
    headers: undefined,
    nameInvalid: false,
    titulo: null,
    loginService: new LoginService(),
  }),

  validations() {
    if (this.datoFiscal.tipoPersona === 2) {
      return {
        datoFiscal: {
          rfc: { required, minLength: minLength(13), maxLength: maxLength(13) },
          regimenFiscal: {required},
          nombre: { required },
          paterno: { required },
          materno: { },
          correo: { required, email },
          cp: { numeric, maxLength: maxLength(5), required },
        },
      };
    } else {
      return {
        datoFiscal: {
          rfc: { required, minLength: minLength(12), maxLength: maxLength(12) },
          regimenFiscal: {required},
          nombreCompleto: { required },
          correo: { required, email },
          cp: { numeric, maxLength: maxLength(5), required },
        },
      };
    }
  },

  created() {
    this.tab1 = true;
    this.tab2 = false;
    this.tab3 = false;
    this.tab4 = false;
    this.disabled1 = false;
    this.disabled2 = true;
    this.disabled3 = true;
    this.disabled4 = true;
    this.generarToken();
    this.debug = this.$localStorageService.getDebug();
  },

  methods: {

    generarToken() {
       this.loginService.login(
        process.env.VUE_APP_ACCESS_FACTURACION_USER,
        process.env.VUE_APP_ACCESS_FACTURACION_DATO
      ).then(response => {
        this.headers = response.Authentication;
         this.listaFiscal();
      });
    },

    listaFiscal() {
      const parametros = {idTipoPersona: this.datoFiscal.tipoPersona}
      this.$http.post(this.$api + 'catalogos/regimenFiscal/obtener/activo',parametros,{ 'headers': { 'Authorization': this.headers}}).then(respuesta => {
        if (respuesta.data.data) {
          this.regimenFiscales = respuesta.data.data;
        }
      })
          .catch((err) => {
            this.errorMensaje(err);
          });

    },

    obtenerRecibos() {
      this.loaderRecibo = true;
      this.datosTablaRecibo = [];
      this.$http
        .post(
          this.$api + "fiscales/obtener/recibos", this.idPaciente, { 'headers': { 'Authorization': this.headers}}
        )
        .then((respuesta) => {
          if (respuesta.data.data) {
            this.datosTablaRecibo = [];
            respuesta.data.data
              .filter(
                (r) =>
                  r.facturado == false && r.activo == true && r.montopagado > 0
              )
              .map((it) => {
                it.loaderRecibo = false;
                this.datosTablaRecibo.push(it);
              });
          }
        })
        .finally(() => {
          this.loaderRecibo = false;
        });
    },

    obtenerFacturas() {
      this.loaderFacturas = true;
      this.datosTablaFacturas = [];
      this.$http
        .post(
          this.$api + "fiscales/obtener/facturas", this.idPaciente, { 'headers': { 'Authorization': this.headers}})
        .then((respuesta) => {
          if (respuesta.data.data) {
            this.datosTablaFacturas = [];
            respuesta.data.data
              .filter((t) => {
                return t.estatus !== "Cancelado";
              })
              .map((it) => {
                it.loaderRecibo = false;
                it.loadercancelar = false;
                this.datosTablaFacturas.push(it);
              });
          }
        })
        .finally(() => {
          this.loaderFacturas = false;
        });
    },

    obtenerRfcs() {
      const params = {
        idPaciente: this.idPaciente
      }
      this.$http
        .post(
          this.$api +
            "fiscales/obtener/datosFiscales", params,  { 'headers': { 'Authorization': this.headers}}
        )
        .then((respuesta) => {
          if (respuesta.data.data) {
            this.datosFiscales = respuesta.data.data.filter((t) => t.activo);
          }
        });
    },

    descargarFactura(datos) {
      const pdf = datos.pdf;
      const xml = datos.xml;
      const folio = datos.uid;
      const zip = new JSZip();
      zip.file(folio + ".xml", xml, { base64: false });
      zip.file(folio + ".pdf", pdf, { base64: true });
      zip.generateAsync({ type: "blob" }).then(function (content) {
        saveAs(content, folio + ".zip");
      });
    },

    zipFactura(item) {
      if (item.url === null) {
        item.loaderRecibo = true;
        this.$http
          .get(this.$api + "reportes/factura?idFactura=" + item.idFactura, { 'headers': { 'Authorization': this.headers}})
          .then((respuesta) => {
            if (respuesta.data.data) {
              const datos = respuesta.data.data;
              this.descargarFactura(datos);
            }
          })
          .finally(() => {
            item.loaderRecibo = false;
          });
      } else {
        window.open(item.url);
      }
    },

    realizarFactura() {
      if (this.factura.idDatosFiscales != null) {
          if(this.factura.cfdi == null){
            this.$swal.fire({
              icon: "info",
              title: "Aviso",
              text: "Seleccione un CFDI",
            });
            return false;
        }
        this.$swal.fire({
            title: "<h6><b>Estos datos son los que se enviaran <br>¿Estas seguro de facturar?</b></h6>",
            html: '<h6>RFC: <span class="text-secondary"><small>'+ this.factura.idDatosFiscales.rfc +'</small></span></h6>'+
            '<h6 class="ml-4">Razón Social: <span class="text-secondary"><small>'+ this.factura.idDatosFiscales.nombreCompleto +'</small></span></h6>'+
            '<h6 style="margin-right: 152px;">Correo Electrónico: <span class="text-secondary"><small>'+ this.factura.idDatosFiscales.correo +'</small></span></h6>',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Si',
            cancelButtonText: 'No'
        }).then((result) => {
          if (result.isConfirmed) {
              this.loaderFacturar = true;
              this.factura.horas = this.$horas();
              this.factura.puede = false;
              const envio = JSON.parse(JSON.stringify(this.factura));
              envio.idDatosFiscales = this.factura.idDatosFiscales.idDatosFiscales;
              this.$http
              .post(this.$api + "facturacion/timbrar", envio, { 'headers': { 'Authorization': this.headers}})
              .then((respuesta) => {
                if (respuesta.data.data) {
                  if (respuesta.data.data.includes("exito")) {
                    this.$swal.fire({
                      icon: "success",
                      title: "Genial",
                      text: "¡Se generó la factura correctamente!",
                    });
                    this.tab3 = false;
                    this.tab4 = true;
                    this.disabled3 = true;
                    this.disabled4 = false;
                    this.obtenerFacturas();
                  } else {
                    let msj = "400 BAD REQUEST: [{\"message\": \"La raz\\u00f3n social no coincide\", \"data\": {}}]";
                      if(respuesta.data.data === msj){
                        this.$swal.fire({
                        icon: "error",
                        title: "Aviso",
                        text: respuesta.data.data,
                        showCancelButton: true,
                        confirmButtonText: 'Verificar Datos',
                        cancelButtonText: 'Cancelar',
                      }).then((result) => {
                        if (result.isConfirmed) {
                          //* Tomara los datos fiscales de lo que viene de factura.idDatosFiscales para editarlos
                          this.datoFiscal = this.factura.idDatosFiscales;
                          this.titulo = 'Verificar Datos Fiscales'
                          this.nameInvalid = true;
                          this.showModal = true;
                        }
                      })
                    }else{
                      this.$swal.fire({
                        icon: "error",
                        title: "Aviso",
                        html: respuesta.data.data,
                      });
                    }
                  }
                }
              })
              .finally(() => {
                this.loaderFacturar = false;
              });
           }
       })
       
      } else {
        this.$swal.fire({
          icon: "info",
          title: "Aviso",
          text: "Seleccione un RFC para poder facturar",
        });
      }
    },

    guardarRFC() {
        this.$v.datoFiscal.$touch();
        if (this.$v.datoFiscal.$anyError) {
          return;
        }
        if (!this.$v.datoFiscal.$invalid) {
          this.loaderAcciones = true;
          this.nombre();
          this.$http
            .post(this.$api + "fiscales/guardar/datosFiscales", this.datoFiscal, { 'headers': { 'Authorization': this.headers}})
            .then((respuesta) => {
              if (respuesta.data.data) {
                this.obtenerRfcs();
                this.showModal = false;
                this.$swal.fire({
                  icon: "success",
                  title: "Muy Bien",
                  text: "¡Los datos se guardaron correctamente!",
                });
              }
            })
            .catch((reason) => {
              this.$swal.fire({
                icon: "info",
                title: "Aviso",
                text: reason.response.data.message,
              });
            })
            .finally(() => {
              this.loaderAcciones = false;
            });
        }
    },

    nombre() {
      if (this.datoFiscal.tipoPersona === 1) {
        this.datoFiscal.nombre = "";
        this.datoFiscal.paterno = "";
        this.datoFiscal.materno = "";
        this.datoFiscal.nombreCompleto =
          this.datoFiscal.nombreCompleto.trimStart();
        this.datoFiscal.nombreCompleto =
          this.datoFiscal.nombreCompleto.trimEnd();
      } else {
        this.datoFiscal.nombre = this.datoFiscal.nombre.trimStart();
        this.datoFiscal.paterno = this.datoFiscal.paterno.trimStart();
        this.datoFiscal.nombre = this.datoFiscal.nombre.trimEnd();
        this.datoFiscal.paterno = this.datoFiscal.paterno.trimEnd();
        if(this.datoFiscal.materno != null){
          this.datoFiscal.materno = this.datoFiscal.materno.trimStart();
          this.datoFiscal.materno = this.datoFiscal.materno.trimEnd();
        }
      }
    },

    siguiente() {
    
      if (this.idPaciente === null) {
        this.$swal({
          icon: "info",
          title: "Aviso",
          text: "Ingrese su número de paciente",
          confirmButtonText: "OK",
          confirmButtonColor: "#0e6ba9",
        });
        return false;
      } else if (this.option === null) {
        this.$swal({
          icon: "info",
          title: "Aviso",
          text: "Seleccione facturar nuevo o consultar facturas",
          confirmButtonText: "OK",
          confirmButtonColor: "#0e6ba9",
        });
        return false;
      } else {
        if (this.option == "A") {
          this.selected = "A";
          this.tab1 = false;
          this.tab2 = true;
          this.disabled1 = true;
          this.disabled2 = false;
          this.obtenerRecibos();
        } else {
          this.selected = "B";
          this.tab1 = false;
          this.tab2 = false;
          this.disabled1 = false;
          this.disabled2 = false;
          this.obtenerFacturas();
        }
      }
    },

    buscarCp() {
      const params = {
        codigoPostal: this.datoFiscal.cp
      }
      this.$http
          .post(this.$api + "localidad/postales", { 'headers': { 'Authorization': this.headers}}, params)
          .then((respuesta) => {
            if (respuesta.status === 200) {
              if (respuesta.data.data.length > 0) {
                this.localidades = respuesta.data.data;
                this.datoFiscal.estado = this.localidades[0].nombreEstado;
                this.datoFiscal.pais = "MÉXICO";
              }
            }
          });
    },

    siguiente2() {
      this.factura.recibos = [];
      
      this.datosTablaRecibo.forEach((it) => {
        if (it.seleccion) {
          this.factura.idClinica = it.idClinica;
          this.factura.recibos.push(it.idRecibo);
        }
      });
      if (this.factura.recibos.length > 0) {
        this.tab2 = false;
        this.tab3 = true;
        this.disabled2 = true;
        this.disabled3 = false;
      } else {
        this.$swal.fire({
          icon: "info",
          title: "Aviso",
          text: "Seleccione el/los recibos a facturar",
        });
      }

      this.obtenerRfcs();
    },

    cancelar() {
      this.idPaciente = null;
      this.option = null;
      this.selected = null;
      this.tab1 = true;
      this.tab2 = false;
      this.tab3 = false;
      this.tab4 = false;
      this.disabled1 = false;
      this.disabled2 = true;
      this.disabled3 = true;
      this.disabled4 = true;
      this.datosTablaRecibo = [];
      this.datosTablaFacturas = [];
      this.factura.recibos = [];
      this.factura.idDatosFiscales= null;
      this.factura.cfdi = null;
      this.factura.idClinica = null;
      this.factura.datosPaciente = false;
      this.factura.desglosada = false;
      
    },

    add() {
      this.datoFiscal = {
        idPaciente: this.idPaciente,
        idDatosFiscales: null,
        nacionalidad: 1,
        tipoPersona: 1,
        nombre: null,
        nombreCompleto: null,
        rfc: null,
        paterno: null,
        materno: null,
        calle: null,
        numero: null,
        colonia: null,
        cp: null,
        pais: null,
        estado: null,
        correo: null,
        regimenFiscal: null
      };
      this.titulo = 'Agregar datos Fiscales';
      this.showModal = true;
    },

    cerrarModal() {
      this.showModal = false;
    },

    validateState(name) {
      const { $dirty, $error } = this.$v.datoFiscal[name];
      return $dirty ? !$error : null;
    },
  },
  watch: {
    "datoFiscal.cp": function () {
      if (this.datoFiscal.cp.length === 5) {
        this.tieneCp = true;
        this.buscarCp();
      } else {
        this.tieneCp = false;
        this.localidades = [];
        this.datoFiscal.colonia = null;
        this.datoFiscal.estado = null;
        this.datoFiscal.pais = null;
      }
    },
  },
};
</script>

<style scoped>
a > i {
  color: #0e6ba9;
  float: left;
  font-size: 30px;
  padding-left: 10px;
  padding-top: 19px;
}

a > span {
  font-size: 15px;
  padding-left: 5px;
  padding-top: 25px;
  float: left;
  font-weight: 600;
  color: #0e6ba9;
}
h4 {
  color: white;
  font-size: 17px;
  padding-top: 9px;
}

img {
  width: 15%;
  border-radius: 10px;
  float: right;
  display: flex;
}

.tab_container > label > span {
  font-size: 20px;
  color: white;
  background-color: #0e6ba9;
  width: 30px;
  border-radius: 50%;
}

.container {
  margin-top: 10px;
}

.capsula {
  margin: 0 auto;
  width: 85%;
  background: rgb(255, 255, 255);
  border-radius: 10px;
  padding: 20px 30px 0;
  box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px,
    rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px;
}

.input,
.btn {
  border-radius: 20px;
}

.input {
  width: 95%;
}

.imagenes {
  display: table;
  padding-left: 30px;
}

.imagenes > span {
  padding-top: 5px;
  padding-left: 30px;
  font-size: 11px;
  display: table-caption;
  color: rgb(121, 119, 119);
  text-align: center;
}

.zoom {
  padding-top: 15px;
  width: 200px;
  transition: transform 0.2s;
}

.zoom:hover {
  width: 270px;
  transform: scale(1.5);
}

.caja {
  font-size: 13px;
  font-weight: 600;
  text-align: center;
  padding-top: 40px;
  color: #0c69a7;
}

.tabla1 {
  font-size: 11.5px;
}

.tabla2 {
  margin-top: 25px;
  font-size: 11.5px;
}

.capsula > p {
  display: inline-block;
  padding-top: 60px;
  text-align: center;
  font-size: 12px;
  color: #0c69a7;
  font-weight: 600;
}

.capsula > p > span {
  color: #5bb3ee;
  font-weight: 600;
}

.item-2 {
  margin-top: 80px;
  height: 35px;
  border-radius: 40px;
  background-image: linear-gradient(
    270deg,
    #3bb3f0 0,
    #3bb3f0 50%,
    #13a7f1 100%
  );
}

.item-2 > h4 {
  font-weight: 600;
  font-size: 14px;
  color: white;
  padding-left: 15px;
  float: left;
}

.item-3 {
  height: 35px;
  border-radius: 40px;
  margin-top: 10px;
  background-image: radial-gradient(
    circle at 56.16% 120.44%,
    #0e6ba9 0,
    #0e6ba9 50%,
    #0e6ba9 100%
  );
}

.tab_container {
  width: 100%;
  margin: 0 auto;
  padding-top: 50px;
}
.tab_container > input {
  clear: both;
  display: none;
}
.tab_container > section {
  clear: both;
  padding-top: 40px;
  display: none;
}

.tab_container > label {
  font-weight: 700;
  font-size: 18px;
  display: flex;
  justify-content: center;
  float: left;
  width: 25%;
  padding: 1em;
  color: #757575;
  cursor: pointer;
  text-decoration: none;
  text-align: center;
  background: #f0f0f0ef;
  border-radius: 90px;
}

#tab1:checked ~ #content1,
#tab2:checked ~ #content2,
#tab3:checked ~ #content3,
#tab4:checked ~ #content4 {
  display: block;
  background: #fff;
  color: #999;
}

.tab_container .tab-content p,
.tab_container .tab-content h3 {
  -webkit-animation: fadeInScale 0.7s ease-in-out;
  -moz-animation: fadeInScale 0.7s ease-in-out;
  animation: fadeInScale 0.7s ease-in-out;
}
.tab_container .tab-content h3 {
  text-align: center;
  font-size: 18px;
  padding-bottom: 15px;
  border-bottom: 2px solid #f0f0f0;
  text-transform: uppercase;
}

.tab_container [id^="tab"]:checked + label {
  background: #fff;
  box-shadow: inset 0 5px #0e6ba9;
}

.add {
  font-size: 12.5px;
}

.labels {
  font-size: 15px;
}

.nombre {
  font-size: 11px;
  padding-right: 5px;
}

.modal-footer {
  margin: 0 auto;
}

.radios {
  font-size: 13px;
}

/*Media query*/
@media only screen and (max-width: 900px) {
  .tab_container {
    width: 98%;
  }
}

@media only screen and (max-width: 900px) {
  .input {
    width: 143px;
  }
}

/*Content Animation*/
@keyframes fadeInScale {
  0% {
    transform: scale(0.9);
    opacity: 0;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@media screen and (max-width: 480px) {
  .capsula {
    width: calc(100% - 80px);
  }
}
</style>